
      import User from './user.vue'
      import type { App, Plugin } from 'vue'

      export const UserPlugin: Plugin = {
        install(app: App) {
          app.component('User', User)
        },
      }
      export { User }
      